import { Navigate, Outlet } from 'react-router-dom';

import { SESSION_STORAGE } from '@/constants/enum';
import { useAppSelector } from '@/hooks/useRedux';

import { ROOT_PATH } from './router.types';

const AuthRoutes = () => {
    const user = useAppSelector(state => state.userReducer.user);

    const isDevicePassword = sessionStorage.getItem(
        SESSION_STORAGE.devicePassword,
    );

    if (user?.token && user?.token !== '' && isDevicePassword) {
        return <Navigate to={ROOT_PATH.home} />;
    }

    return <Outlet />;
};

export default AuthRoutes;
